export default __webpack_public_path__ + "static/media/eco4.a0ebedaf.jpg";